import { useNavigate } from 'react-router-dom'
import { TarefasPage } from '@/pages/TarefasPage'
import styles from './Profissional.module.css'

export function ProfissionalTarefasPage() {
  const navigate = useNavigate()

  return (
    <main className={styles.panel}>
      <div className={styles.panelWrap}>
        <header className={styles.hero}>
          <div className={styles.heroLeft}>
            <div>
              <p className={styles.heroKicker}>Painel do profissional</p>
              <h1 className={styles.panelTitle}>Tarefas</h1>
              <p className={styles.heroMeta}>Categorias, lista e calendário</p>
            </div>
          </div>
          <button
            type="button"
            className={styles.logoutBtn}
            onClick={() => navigate('/profissional/painel')}
          >
            Voltar
          </button>
        </header>
        <TarefasPage />
      </div>
    </main>
  )
}
